import { MessageSchema } from "@redotech/redo-model/agents/llm-messages";
import * as z from "zod";

export const sendChatOnboardingMessage = {
  name: "sendChatOnboardingMessage" as const,
  input: z.object({
    messages: z.array(MessageSchema),
    currentConfig: z.record(z.string(), z.any()),
  }),
  output: z.object({ messages: z.array(MessageSchema) }),
};
